import { features } from '@/mocks/content';

export default function Features() {
  return (
    <section className="py-16 md:py-24 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12 md:mb-16">
          <h2 className="text-3xl md:text-4xl font-bold font-heading text-foreground-900 mb-4">
            为什么选择男同网
          </h2>
          <p className="text-foreground-500 text-base max-w-xl mx-auto leading-relaxed">
            我们致力于为每一位社群成员打造一个安全、温暖、有价值的线上家园
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
          {features.map((feature, index) => (
            <div
              key={index}
              className="group p-6 md:p-7 rounded-xl bg-background-100 border border-background-200/70 hover:border-primary-200/50 transition-all duration-300"
            >
              <div className="w-12 h-12 flex items-center justify-center rounded-lg bg-primary-100 text-primary-600 mb-5 group-hover:bg-primary-500 group-hover:text-white transition-all duration-300">
                <i className={`${feature.icon} text-xl`}></i>
              </div>
              <h3 className="text-lg font-semibold text-foreground-900 mb-2 font-heading">{feature.title}</h3>
              <p className="text-sm text-foreground-500 leading-relaxed">{feature.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}